/**
 * Converts meters to miles.
 * There are 1609.344 meters in a mile, so the equation is simple:
 *
 * miles = meters / 1609.344
 */
export function metersToMiles(meters: number): number {
  const METERS_IN_A_MILE = 1609.344;

  if (meters === 0) {
    return 0;
  }

  const miles = meters / METERS_IN_A_MILE;

  return Math.round((miles + Number.EPSILON) * 100) / 100;
}
